module.exports = __webpack_public_path__ + "static/media/existing_contract.8728dda8.svg";